import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import {
  SaveButton,
  TextInput,
  SimpleForm,
  useDataProvider,
  useNotify,
  NumberInput,
  BooleanInput,
  useRefresh,
  useTranslate,
} from 'react-admin';

export default function CreateTask({ onClose }: { onClose: () => void }) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const translate = useTranslate();
  const [saving, setSaving] = useState(false);
  const refresh = useRefresh();
  const onSubmit = async (values: any) => {
    setSaving(true);
    try {
      const processedValues = {
        ...values,
        name: typeof values.name === 'object' ? values.name : { en: values.name || '' },
        points: Number(values.points) || 0,
        isActive: Boolean(values.isActive),
      };

      await dataProvider.create('activity-tier-benefit', { data: processedValues });
      notify(translate('activity.tierBenefits.createdSuccessfully'), { type: 'success' });
      refresh();
      onClose();
    } catch (error) {
      console.error('Create error:', error);
      notify(translate('activity.tierBenefits.failedToCreate'), { type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DialogTitle>{translate('activity.common.createTask')}</DialogTitle>
      <DialogContent>
        <SimpleForm onSubmit={onSubmit} toolbar={<SaveButton alwaysEnable disabled={saving} />}>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Typography variant="h6">{translate('activity.common.basicInformation')}</Typography>
            <TextInput source="tierName" label={translate('activity.tierBenefits.tierName')} fullWidth required />
            <NumberInput source="tierLevel" label={translate('activity.tierBenefits.tierLevel')} fullWidth required defaultValue={0} />
            <NumberInput source="minPoints" label={translate('activity.tierBenefits.minPoints')} fullWidth required defaultValue={0} />
            <TextInput source="cashbackPercentage" label={translate('activity.tierBenefits.cashbackPercentage')} fullWidth required />
            <TextInput source="referredIncentivePercentage" label={translate('activity.tierBenefits.referredIncentivePercentage')} fullWidth required />
            <TextInput source="futureCashbackPercentage" label={translate('activity.tierBenefits.futureCashbackPercentage')} fullWidth required />
            <TextInput source="netFee" label={translate('activity.tierBenefits.netFee')} fullWidth required />
            <TextInput source="benefitsDescription" label={translate('activity.common.description')} fullWidth multiline rows={3} />
            <TextInput source="tierColor" label={translate('activity.common.color')} fullWidth />
            <TextInput source="tierIcon" label={translate('activity.common.icon')} fullWidth />
          </Stack>
        </SimpleForm>
      </DialogContent>
    </>
  );
}
